import { doAjax } from './helper'
import { getInteriorImageForStoredComponent} from './imagesLogicController'
import { saveStateWithAjax, getPackageImageSource, checkKey, checkSubmit } from './screen-package-selection-global'


function checkSeatsAndSteeringWheelBadges_a6_c9_s_line() {
	const imgSource = 'img/01_interieur/paketauswahl/au513_e-tron_gt_paketauswahl_rs_badges_zierleiste.png'
}


function addListeners_a6_c9_s_line(frontCheckboxesMap, modalsCheckboxesMap) {

	//console.log("reload? 0")
	// Remove YFB layer onLoad if package and YN1 OR YN2 active
	function checkYFB() {
		document.getElementById("YFB_A6_C9-img").hidden = true;
		//console.log("reload? 1")
	}
	function checkYFB_YN1() {
		document.getElementById("YFB_A6_C9-img").hidden = true;
		//console.log("reload? 2")
	}
	if ((frontCheckboxesMap['YFB_A6_C9'].checked == true) && (frontCheckboxesMap['YN1_A6_C9'].checked == true)) { 
		setTimeout(checkYFB_YN1, 100);
	}
	if ((frontCheckboxesMap['YFB_A6_C9'].checked == true) && (frontCheckboxesMap['YN2_A6_C9'].checked == true)) { 
		setTimeout(checkYFB, 100);
	}

    frontCheckboxesMap['FC1_A6_C9'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('FC1_A6_C9', this.checked);
		if (this.checked) {
			if (frontCheckboxesMap['YN1_A6_C9'].checked == false) { 
				frontCheckboxesMap['YN1_A6_C9'].disabled = true
			}
			if (frontCheckboxesMap['YN2_A6_C9'].checked == false) { 
				frontCheckboxesMap['YN2_A6_C9'].disabled = true
			}
			if (frontCheckboxesMap['YFB_A6_C9'].checked == false) { 
				frontCheckboxesMap['YFB_A6_C9'].disabled = true
			}
		} else {
			checkLocks_a6_c9_s_line(frontCheckboxesMap)
		}
		getPackageImages_a6_c9_s_line('FC1_A6_C9', frontCheckboxesMap)
	})

	frontCheckboxesMap['Q8H_A6_C9'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('Q8H_A6_C9', this.checked);
		saveStateWithAjax('7HF_A6_C9', false);
		if (this.checked) {

			if (frontCheckboxesMap['YN1_A6_C9'].checked == false) { 
				frontCheckboxesMap['YN1_A6_C9'].disabled = true
			}
			if (frontCheckboxesMap['YN2_A6_C9'].checked == false) { 
				frontCheckboxesMap['YN2_A6_C9'].disabled = true
			}
			if (frontCheckboxesMap['YFB_A6_C9'].checked == false) { 
				frontCheckboxesMap['YFB_A6_C9'].disabled = true
			}
			
			/* Clean popup checkboxes */
			jQuery("#Q8H_7HH_A6_C9").addClass("is-checked");
			jQuery("#7HF_A6_C9").removeClass("is-checked");
			jQuery("#Q8H_7HH_A6_C9 .aui-checkbox__input").prop("disabled", false);
			jQuery("#7HF_A6_C9 .aui-checkbox__input").prop("disabled", false);
			jQuery("#submit_button").prop("disabled", false);
			/* Clean popup checkboxes */

			/* set default */
			//saveStateWithAjax('Q8H_A6_C9', true);
			//jQuery("#Q8H_7HH_A6_C9").addClass("is-checked");
			//jQuery("#submit_button").prop("disabled", false);

		} else {
			checkLocks_a6_c9_s_line(frontCheckboxesMap)
			saveStateWithAjax('Q8H_A6_C9', false);
			saveStateWithAjax('7HF_A6_C9', false);
		}
		//CheckModalVisibility
		var CarmodelPopUp = document.querySelector("input[name='carmodel']").value
		if ((CarmodelPopUp == 60) || (CarmodelPopUp == 61) || (CarmodelPopUp == 62) || (CarmodelPopUp == 63) || (CarmodelPopUp == 64) || (CarmodelPopUp == 65))  {
			const modal = document.querySelectorAll('.modal_a6_c9')[0]
			if (this.checked) {
				modal.classList.remove("hidden")		
			} else {
				modal.classList.add("hidden")
			}
		}
		getPackageImages_a6_c9_s_line('Q8H_A6_C9', frontCheckboxesMap)
		getPackageImages_a6_c9_s_line('7HF_A6_C9', frontCheckboxesMap)
    })

	frontCheckboxesMap['7HF_A6_C9'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('Q8H_A6_C9', false);
		saveStateWithAjax('7HF_A6_C9', this.checked);
		if (this.checked) {

			if (frontCheckboxesMap['YN1_A6_C9'].checked == false) { 
				frontCheckboxesMap['YN1_A6_C9'].disabled = true
			}
			if (frontCheckboxesMap['YN2_A6_C9'].checked == false) { 
				frontCheckboxesMap['YN2_A6_C9'].disabled = true
			}
			if (frontCheckboxesMap['YFB_A6_C9'].checked == false) { 
				frontCheckboxesMap['YFB_A6_C9'].disabled = true
			}
			
			/* Clean popup checkboxes */
			jQuery("#Q8H_7HH_A6_C9").removeClass("is-checked");
			jQuery("#7HF_A6_C9").addClass("is-checked");
			jQuery("#Q8H_7HH_A6_C9 .aui-checkbox__input").prop("disabled", false);
			jQuery("#7HF_A6_C9 .aui-checkbox__input").prop("disabled", false);
			jQuery("#submit_button").prop("disabled", false);
			/* Clean popup checkboxes */

			/* set default */
			//saveStateWithAjax('Q8H_A6_C9', true);
			//jQuery("#Q8H_7HH_A6_C9").addClass("is-checked");
			//jQuery("#submit_button").prop("disabled", false);

		} else {
			checkLocks_a6_c9_s_line(frontCheckboxesMap)
			saveStateWithAjax('Q8H_A6_C9', false);
			saveStateWithAjax('7HF_A6_C9', false);
		}
		//CheckModalVisibility
		var CarmodelPopUp = document.querySelector("input[name='carmodel']").value
		if ((CarmodelPopUp == 60) || (CarmodelPopUp == 61) || (CarmodelPopUp == 62) || (CarmodelPopUp == 63) || (CarmodelPopUp == 64) || (CarmodelPopUp == 65))  {
			const modal = document.querySelectorAll('.modal_a6_c9')[0]
			if (this.checked) {
				modal.classList.remove("hidden")		
			} else {
				modal.classList.add("hidden")
			}
		}
		getPackageImages_a6_c9_s_line('7HF_A6_C9', frontCheckboxesMap)
		getPackageImages_a6_c9_s_line('Q8H_A6_C9', frontCheckboxesMap)
    })

	frontCheckboxesMap['0UD_A6_C9'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('0UD_A6_C9', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YN1_A6_C9'].checked == false) { 
				frontCheckboxesMap['YN1_A6_C9'].disabled = true
			}
			//If we dont come from the modal
			if (frontCheckboxesMap['YN2_A6_C9'].checked == false) { 
				frontCheckboxesMap['YN2_A6_C9'].disabled = true
			}
			if (frontCheckboxesMap['YFB_A6_C9'].checked == false) { 
				frontCheckboxesMap['YFB_A6_C9'].disabled = true
			}
		} else {
			checkLocks_a6_c9_s_line(frontCheckboxesMap)
		}
		getPackageImages_a6_c9_s_line('0UD_A6_C9', frontCheckboxesMap)
	})
	
	frontCheckboxesMap['7TZ_A6_C9'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('7TZ_A6_C9', this.checked);
		if (this.checked) {
			//If we dont come from the modal

			// prevent "next" button without selecting YN1 OR YN2 when YFB checked
			if ((frontCheckboxesMap['YN1_A6_C9'].checked == false) && (frontCheckboxesMap['YN2_A6_C9'].checked == false) && (frontCheckboxesMap['YFB_A6_C9'].checked == true)) { 
				jQuery("#navigation-submit-btn").prop("disabled", true);
			}

		} else {
			checkLocks_a6_c9_s_line(frontCheckboxesMap)

			// prevent "next" button without selecting YN1 OR YN2 when YFB checked
			if ((frontCheckboxesMap['YN1_A6_C9'].checked == false) && (frontCheckboxesMap['YN2_A6_C9'].checked == false) && (frontCheckboxesMap['YFB_A6_C9'].checked == true)) { 
				jQuery("#navigation-submit-btn").prop("disabled", true);
			}
		}
		getPackageImages_a6_c9_s_line('7TZ_A6_C9', frontCheckboxesMap)
	})

	frontCheckboxesMap['FZ9_A6_C9'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('FZ9_A6_C9', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['FZ8_A6_C9'].checked == false) { 
				frontCheckboxesMap['FZ8_A6_C9'].disabled = true
			}

			// prevent "next" button without selecting YN1 OR YN2 when YFB checked
			if ((frontCheckboxesMap['YN1_A6_C9'].checked == false) && (frontCheckboxesMap['YN2_A6_C9'].checked == false) && (frontCheckboxesMap['YFB_A6_C9'].checked == true)) { 
				jQuery("#navigation-submit-btn").prop("disabled", true);
			}

		} else {
			checkLocks_a6_c9_s_line(frontCheckboxesMap)

			// prevent "next" button without selecting YN1 OR YN2 when YFB checked
			if ((frontCheckboxesMap['YN1_A6_C9'].checked == false) && (frontCheckboxesMap['YN2_A6_C9'].checked == false) && (frontCheckboxesMap['YFB_A6_C9'].checked == true)) { 
				jQuery("#navigation-submit-btn").prop("disabled", true);
			}
		}
		getPackageImages_a6_c9_s_line('FZ9_A6_C9', frontCheckboxesMap)
	})

	frontCheckboxesMap['FZ8_A6_C9'].addEventListener('change', function () {
			checkSubmit(frontCheckboxesMap)
			saveStateWithAjax('FZ8_A6_C9', this.checked);
			if (this.checked) {
				//If we dont come from the modal
				if (frontCheckboxesMap['FZ9_A6_C9'].checked == false) { 
					frontCheckboxesMap['FZ9_A6_C9'].disabled = true
				}

				// prevent "next" button without selecting YN1 OR YN2 when YFB checked
				if ((frontCheckboxesMap['YN1_A6_C9'].checked == false) && (frontCheckboxesMap['YN2_A6_C9'].checked == false) && (frontCheckboxesMap['YFB_A6_C9'].checked == true)) { 
					jQuery("#navigation-submit-btn").prop("disabled", true);
				}

			} else {
				checkLocks_a6_c9_s_line(frontCheckboxesMap)

				// prevent "next" button without selecting YN1 OR YN2 when YFB checked
				if ((frontCheckboxesMap['YN1_A6_C9'].checked == false) && (frontCheckboxesMap['YN2_A6_C9'].checked == false) && (frontCheckboxesMap['YFB_A6_C9'].checked == true)) { 
					jQuery("#navigation-submit-btn").prop("disabled", true);
				}
			}
			getPackageImages_a6_c9_s_line('FZ8_A6_C9', frontCheckboxesMap)
		})

    frontCheckboxesMap['0TF_A6_C9'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('0TF_A6_C9', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YN1_A6_C9'].checked == false) { 
				frontCheckboxesMap['YN1_A6_C9'].disabled = true
			}
			//If we dont come from the modal
			if (frontCheckboxesMap['YN2_A6_C9'].checked == false) { 
				frontCheckboxesMap['YN2_A6_C9'].disabled = true
			}
			if (frontCheckboxesMap['YFB_A6_C9'].checked == false) { 
				frontCheckboxesMap['YFB_A6_C9'].disabled = true
			}
		} else {
			checkLocks_a6_c9_s_line(frontCheckboxesMap)
		}
		getPackageImages_a6_c9_s_line('0TF_A6_C9', frontCheckboxesMap)
	})


	frontCheckboxesMap['YN1_A6_C9'].addEventListener('change', function () {
		
		//Basisbild austauschen
		updateBackgroundImage();

		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YN1_A6_C9', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YN2_A6_C9'].checked == false) { 
				frontCheckboxesMap['YN2_A6_C9'].disabled = true
			}
			if (frontCheckboxesMap['FC1_A6_C9'].checked == false) { 
				frontCheckboxesMap['FC1_A6_C9'].disabled = true
			}
			if (frontCheckboxesMap['Q8H_A6_C9'].checked == false) { 
				frontCheckboxesMap['Q8H_A6_C9'].disabled = true
			}
			if (frontCheckboxesMap['0UD_A6_C9'].checked == false) { 
				frontCheckboxesMap['0UD_A6_C9'].disabled = true
			}
			if (frontCheckboxesMap['0TF_A6_C9'].checked == false) { 
				frontCheckboxesMap['0TF_A6_C9'].disabled = true
			}
			if (frontCheckboxesMap['YFA_A6_C9'].checked == false) { 
				frontCheckboxesMap['YFA_A6_C9'].disabled = true
			}

			// Remove YFB layer if package active
			if (frontCheckboxesMap['YFB_A6_C9'].checked == true) { 
				document.getElementById("YFB_A6_C9-img").hidden = true;
			}

		} else {
			checkLocks_a6_c9_s_line(frontCheckboxesMap)

			// Add YFB layer if package active
			if (frontCheckboxesMap['YFB_A6_C9'].checked == true) { 
				document.getElementById("YFB_A6_C9-img").hidden = false;
			}

			// prevent "next" button when YFB selected
			if ((frontCheckboxesMap['YFB_A6_C9'].checked == true)) { 
				jQuery("#navigation-submit-btn").prop("disabled", true);
			}

		}
		getPackageImages_a6_c9_s_line('YN1_A6_C9', frontCheckboxesMap)
	})	

	frontCheckboxesMap['YN2_A6_C9'].addEventListener('change', function () {
		
		//Basisbild austauschen
		updateBackgroundImage();

		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YN2_A6_C9', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YN1_A6_C9'].checked == false) { 
				frontCheckboxesMap['YN1_A6_C9'].disabled = true
			}
			if (frontCheckboxesMap['FC1_A6_C9'].checked == false) { 
				frontCheckboxesMap['FC1_A6_C9'].disabled = true
			}
			if (frontCheckboxesMap['Q8H_A6_C9'].checked == false) { 
				frontCheckboxesMap['Q8H_A6_C9'].disabled = true
			}
			if (frontCheckboxesMap['0UD_A6_C9'].checked == false) { 
				frontCheckboxesMap['0UD_A6_C9'].disabled = true
			}
			if (frontCheckboxesMap['0TF_A6_C9'].checked == false) { 
				frontCheckboxesMap['0TF_A6_C9'].disabled = true
			}
			if (frontCheckboxesMap['YFA_A6_C9'].checked == false) { 
				frontCheckboxesMap['YFA_A6_C9'].disabled = true
			}

			// Remove YFB layer if package active
			if (frontCheckboxesMap['YFB_A6_C9'].checked == true) { 
				document.getElementById("YFB_A6_C9-img").hidden = true;
			}

		} else {
			checkLocks_a6_c9_s_line(frontCheckboxesMap)

			// Add YFB layer if package active
			if (frontCheckboxesMap['YFB_A6_C9'].checked == true) { 
				document.getElementById("YFB_A6_C9-img").hidden = false;
			}


			// prevent "next" button when YFB selected
			if ((frontCheckboxesMap['YFB_A6_C9'].checked == true)) { 
				jQuery("#navigation-submit-btn").prop("disabled", true);
			}
		}
		getPackageImages_a6_c9_s_line('YN2_A6_C9', frontCheckboxesMap)
	})
	

	frontCheckboxesMap['YFA_A6_C9'].addEventListener('change', function () {
		
		//Basisbild austauschen
		updateBackgroundImage();
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YFA_A6_C9', this.checked);

		// activate all connected packages
		if (frontCheckboxesMap['YFA_A6_C9'].checked == false) { 
			saveStateWithAjax('FC1_A6_C9', this.checked);
			frontCheckboxesMap['FC1_A6_C9'].parentElement.classList.remove('is-checked')
			saveStateWithAjax('Q8H_A6_C9', this.checked);
			frontCheckboxesMap['Q8H_A6_C9'].parentElement.classList.remove('is-checked')
			saveStateWithAjax('7HF_A6_C9', this.checked);
			frontCheckboxesMap['7HF_A6_C9'].parentElement.classList.remove('is-checked')
			saveStateWithAjax('0UD_A6_C9', this.checked);
			frontCheckboxesMap['0UD_A6_C9'].parentElement.classList.remove('is-checked')
			saveStateWithAjax('0TF_A6_C9', this.checked);
			frontCheckboxesMap['0TF_A6_C9'].parentElement.classList.remove('is-checked')
			jQuery("#7HF_A6_C9-img").attr("hidden", true);
			jQuery("#Q8H_A6_C9-img").attr("hidden", true);
		} else {
			saveStateWithAjax('FC1_A6_C9', this.checked);
			frontCheckboxesMap['FC1_A6_C9'].parentElement.classList.add('is-checked')
			if (frontCheckboxesMap['Q8H_A6_C9'].checked == false && frontCheckboxesMap['7HF_A6_C9'].checked == false) {
				saveStateWithAjax('Q8H_A6_C9', this.checked);
				frontCheckboxesMap['Q8H_A6_C9'].parentElement.classList.add('is-checked');
			}
			saveStateWithAjax('0UD_A6_C9', this.checked);
			frontCheckboxesMap['0UD_A6_C9'].parentElement.classList.add('is-checked')
			saveStateWithAjax('0TF_A6_C9', this.checked);
			frontCheckboxesMap['0TF_A6_C9'].parentElement.classList.add('is-checked')
		}

		if (this.checked) {

			// cannot change connected packages
			let packageIds = ["FC1_A6_C9", "Q8H_A6_C9", "7HF_A6_C9", "0UD_A6_C9", "0TF_A6_C9"];
			packageIds.forEach(function(id) {
				frontCheckboxesMap[id].disabled = true
			});

			//If we dont come from the modal
			if (frontCheckboxesMap['YFB_A6_C9'].checked == false) { 
				frontCheckboxesMap['YFB_A6_C9'].disabled = true
			}
			if (frontCheckboxesMap['YN1_A6_C9'].checked == false) { 
				frontCheckboxesMap['YN1_A6_C9'].disabled = true
			}
			if (frontCheckboxesMap['YN2_A6_C9'].checked == false) { 
				frontCheckboxesMap['YN2_A6_C9'].disabled = true
			}
			if (frontCheckboxesMap['Q8H_A6_C9'].checked == false) { 
				frontCheckboxesMap['Q8H_A6_C9'].checked = false
			}
			if (frontCheckboxesMap['7HF_A6_C9'].checked == false) { 
				frontCheckboxesMap['7HF_A6_C9'].checked = false
			}
			if (frontCheckboxesMap['0UD_A6_C9'].checked == false) { 
				frontCheckboxesMap['0UD_A6_C9'].checked = false
			}
			if (frontCheckboxesMap['0TF_A6_C9'].checked == false) { 
				frontCheckboxesMap['0TF_A6_C9'].checked = false
			}

			//Q8H popup
			//If we dont come from the modal		
			/*
			const boxesToUncheck = ['7HF_A6_C9']
			boxesToUncheck.forEach(key => {
				frontCheckboxesMap[key].parentElement.classList.remove('is-checked')
				this.checked = false
				saveStateWithAjax(key, false)
				getPackageImages_a6_c9_s_line(key, frontCheckboxesMap)
			});	
			*/

			/* Clean popup checkboxes */
			jQuery("#Q8H_7HH_A6_C9").addClass("is-checked");
			jQuery("#7HF_A6_C9").removeClass("is-checked");
			jQuery("#Q8H_7HH_A6_C9 .aui-checkbox__input").prop("disabled", false);
			jQuery("#7HF_A6_C9 .aui-checkbox__input").prop("disabled", false);
			jQuery("#submit_button").prop("disabled", false);
			/* Clean popup checkboxes */






		} else {
			let packageIds = ["FC1_A6_C9", "Q8H_A6_C9", "7HF_A6_C9", "0UD_A6_C9", "0TF_A6_C9"];
			packageIds.forEach(function(id) {
				frontCheckboxesMap[id].disabled = false
			});
			checkLocks_a6_c9_s_line(frontCheckboxesMap)
		}



		//Q8H popup
		//CheckModalVisibility
		var CarmodelPopUp = document.querySelector("input[name='carmodel']").value
		if ((CarmodelPopUp == 60) || (CarmodelPopUp == 61) || (CarmodelPopUp == 62) || (CarmodelPopUp == 63) || (CarmodelPopUp == 64) || (CarmodelPopUp == 65))  {
			const modal = document.querySelectorAll('.modal_a6_c9')[0]
			if (this.checked) {
				modal.classList.remove("hidden")		
			} else {
				modal.classList.add("hidden")
			}
		}

		getPackageImages_a6_c9_s_line('YFA_A6_C9', frontCheckboxesMap)
	})		

	
	

	frontCheckboxesMap['YFB_A6_C9'].addEventListener('change', function () {
		
		//Basisbild austauschen
		updateBackgroundImage();

		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YFB_A6_C9', this.checked);

		if (this.checked) {

			//If we dont come from the modal
			if (frontCheckboxesMap['FC1_A6_C9'].checked == false) { 
				frontCheckboxesMap['FC1_A6_C9'].disabled = true
			}
			if (frontCheckboxesMap['YFA_A6_C9'].checked == false) { 
				frontCheckboxesMap['YFA_A6_C9'].disabled = true
			}
			if (frontCheckboxesMap['Q8H_A6_C9'].checked == false) { 
				frontCheckboxesMap['Q8H_A6_C9'].disabled = true
			}
			if (frontCheckboxesMap['0UD_A6_C9'].checked == false) { 
				frontCheckboxesMap['0UD_A6_C9'].disabled = true
			}
			/*
			if (frontCheckboxesMap['7TZ_A6_C9'].checked == false) { 
				frontCheckboxesMap['7TZ_A6_C9'].disabled = true
			}		
			if (frontCheckboxesMap['FZ9_A6_C9'].checked == false) { 
				frontCheckboxesMap['FZ9_A6_C9'].disabled = true
			}
			if (frontCheckboxesMap['FZ8_A6_C9'].checked == false) { 
				frontCheckboxesMap['FZ8_A6_C9'].disabled = true
			}
			if (frontCheckboxesMap['0TF_A6_C9'].checked == false) { 
				frontCheckboxesMap['0TF_A6_C9'].disabled = true
			}	
			*/	

			// prevent "next" button without selecting YN1 OR YN2
			if ((frontCheckboxesMap['YN1_A6_C9'].checked == false) && (frontCheckboxesMap['YN2_A6_C9'].checked == false)) { 
				jQuery("#navigation-submit-btn").prop("disabled", true);
			}

			// Remove YN1/YN2 layers if packages active
			if ((frontCheckboxesMap['YN1_A6_C9'].checked == true)) { 
				//document.getElementById("YN1_A6_C9-img").hidden = true;
			}
			if ((frontCheckboxesMap['YN2_A6_C9'].checked == true)) { 
				document.getElementById("YN2_A6_C9-img").hidden = true;
			}

		} else {
			checkLocks_a6_c9_s_line(frontCheckboxesMap)

			// Add YN1/YN2 layers if packages active
			if ((frontCheckboxesMap['YN1_A6_C9'].checked == true)) { 
				document.getElementById("YN1_A6_C9-img").hidden = false;
			}
			if ((frontCheckboxesMap['YN2_A6_C9'].checked == true)) { 
				document.getElementById("YN2_A6_C9-img").hidden = false;
			}
		}
		if ((frontCheckboxesMap['YN1_A6_C9'].checked == false)) getPackageImages_a6_c9_s_line('YFB_A6_C9', frontCheckboxesMap)
	})	


}



/**Controls frontcheckboxes disable */
function checkLocks_a6_c9_s_line(frontCheckboxesMap) {
    //DEFINE UNLOCK CONDITIONS	
    const unlockConditionForFC1 = !frontCheckboxesMap['YN1_A6_C9'].checked && !frontCheckboxesMap['YN2_A6_C9'].checked && !frontCheckboxesMap['YFA_A6_C9'].checked && !frontCheckboxesMap['YFB_A6_C9'].checked
    const unlockConditionForYN1 = !frontCheckboxesMap['FC1_A6_C9'].checked && !frontCheckboxesMap['YN2_A6_C9'].checked && !frontCheckboxesMap['Q8H_A6_C9'].checked && !frontCheckboxesMap['0UD_A6_C9'].checked && !frontCheckboxesMap['0TF_A6_C9'].checked && !frontCheckboxesMap['YFA_A6_C9'].checked
    const unlockConditionForYN2 = !frontCheckboxesMap['FC1_A6_C9'].checked && !frontCheckboxesMap['YN1_A6_C9'].checked && !frontCheckboxesMap['Q8H_A6_C9'].checked && !frontCheckboxesMap['0UD_A6_C9'].checked && !frontCheckboxesMap['0TF_A6_C9'].checked && !frontCheckboxesMap['YFA_A6_C9'].checked
    const unlockConditionForQ8H_7HH = !frontCheckboxesMap['YN1_A6_C9'].checked && !frontCheckboxesMap['YN2_A6_C9'].checked && !frontCheckboxesMap['YFA_A6_C9'].checked && !frontCheckboxesMap['YFB_A6_C9'].checked
	const unlockConditionFor0UD = !frontCheckboxesMap['YN1_A6_C9'].checked && !frontCheckboxesMap['YN2_A6_C9'].checked && !frontCheckboxesMap['YFA_A6_C9'].checked && !frontCheckboxesMap['YFB_A6_C9'].checked
	const unlockConditionForFZ8 = !frontCheckboxesMap['FZ9_A6_C9'].checked
	const unlockConditionForFZ9 = !frontCheckboxesMap['FZ8_A6_C9'].checked
	const unlockConditionFor0TF = !frontCheckboxesMap['YN1_A6_C9'].checked && !frontCheckboxesMap['YN2_A6_C9'].checked && !frontCheckboxesMap['YFA_A6_C9'].checked && !frontCheckboxesMap['YFB_A6_C9'].checked
	const unlockConditionForYFA = !frontCheckboxesMap['YN1_A6_C9'].checked && !frontCheckboxesMap['YN2_A6_C9'].checked && !frontCheckboxesMap['YFB_A6_C9'].checked
	const unlockConditionForYFB = !frontCheckboxesMap['YFA_A6_C9'].checked && !frontCheckboxesMap['0TF_A6_C9'].checked

	frontCheckboxesMap['Q8H_A6_C9'].disabled = !unlockConditionForQ8H_7HH
	frontCheckboxesMap['0UD_A6_C9'].disabled = !unlockConditionFor0UD
	frontCheckboxesMap['FZ8_A6_C9'].disabled = !unlockConditionForFZ8
	frontCheckboxesMap['FZ9_A6_C9'].disabled = !unlockConditionForFZ9
	frontCheckboxesMap['0TF_A6_C9'].disabled = !unlockConditionFor0TF

    frontCheckboxesMap['YN1_A6_C9'].disabled = !unlockConditionForYN1
    frontCheckboxesMap['YN2_A6_C9'].disabled = !unlockConditionForYN2
    frontCheckboxesMap['FC1_A6_C9'].disabled = !unlockConditionForFC1

    frontCheckboxesMap['YFA_A6_C9'].disabled = !unlockConditionForYFA
    frontCheckboxesMap['YFB_A6_C9'].disabled = !unlockConditionForYFB
}


/**Gets images for all packages depending on selected packages */

function getImages_a6_c9_s_line(frontCheckboxesMap) {
	for (const checkboxKey in frontCheckboxesMap) {
		getPackageImages_a6_c9_s_line(checkboxKey, frontCheckboxesMap)
	}
}

function getPackageImages_a6_c9_s_line(packageCode, checkboxesMap) {
	let specialPackage = '';
	//When in modal
	if (packageCode == 'YSI-YVJ' || packageCode == 'YSJ_A6-YVJ'){
		specialPackage = packageCode
		packageCode = packageCode == 'YSI-YVJ' ? 'YSI' : 'YSJ_A6'
	}


	const checkboxElement = checkboxesMap[packageCode]
	const imageSource = specialPackage != '' ? getPackageImageSource(specialPackage) : getPackageImageSource(packageCode)
	let pressedPackageImg = document.getElementById(specialPackage != ''? specialPackage + '-img' : packageCode + '-img')
	const isChecked = checkboxElement.checked || checkboxElement.parentElement.classList.contains('is-checked')


    if (checkboxesMap['YFA_A6_C9'] && checkboxesMap['YFA_A6_C9'].checked) {
		setTimeout(function() {
			let imgIds = ["FC1_A6_C9-img", "Q8H_A6_C9-img", "0UD_A6_C9-img", "0TF_A6_C9-img"];
			imgIds.forEach(function(id) {
				//console.log("hide image " + id)
				let img = document.getElementById(id);
				if (img) img.setAttribute("hidden", "");
			});
		}, 200);
	}


	//if image does not exist we create it
	if (pressedPackageImg == null) {
		if (!isChecked ) return
		let imageArray = document.querySelector('.image-wrap')
		let newImage = document.createElement('IMG')
		newImage.classList.add('overlay')
		newImage.src = imageSource
		newImage.id = specialPackage != '' ? specialPackage + '-img' : packageCode + '-img'
		imageArray.insertAdjacentElement('beforeend', newImage)
	} else {
		pressedPackageImg.hidden = !isChecked
	}
}



function updateBackgroundImage() {
	const isYN1_A6_C9_Checked = isCheckboxCheckedByAuiCode('YN1_A6_C9');
	const isYN2_A6_C9_Checked = isCheckboxCheckedByAuiCode('YN2_A6_C9');
	//Basisbild austauschen
    if (isYN1_A6_C9_Checked) {		
		document.getElementById("front_background_image").src="img/06_paketauswahl/a6/au592_a6_paketauswahl_sline_s_yn1/au592_a6_sline_s_yn1_paketauswahl.png";
	} else if (isYN2_A6_C9_Checked) {
		document.getElementById("front_background_image").src="img/06_paketauswahl/a6/au592_a6_paketauswahl_sline_s_yn2/au592_a6_sline_s_yn1_paketauswahl.png";
	} else {
		document.getElementById("front_background_image").src="img/06_paketauswahl/a6/au592_a6_paketauswahl_sline_s/au592_a6_sline_s_paketauswahl.png";
	}
}

function isCheckboxCheckedByAuiCode(auiCode) {
    const label = document.querySelector(`label[data-auicode="${auiCode}"]`);
    if (label) {
        const checkbox = label.querySelector('input[type="checkbox"]');
        return checkbox ? checkbox.checked : false;
    }
    return false;
}

document.addEventListener('DOMContentLoaded', function () {
	const isYN1_A6_C9_Checked = isCheckboxCheckedByAuiCode('YN1_A6_C9');
	if(isYN1_A6_C9_Checked) {
		updateBackgroundImage();
	}
	const isYN2_A6_C9_Checked = isCheckboxCheckedByAuiCode('YN2_A6_C9');
	if(isYN2_A6_C9_Checked) {
		updateBackgroundImage();
	}
	
});

export { addListeners_a6_c9_s_line, saveStateWithAjax, checkLocks_a6_c9_s_line, getImages_a6_c9_s_line, getPackageImages_a6_c9_s_line, checkSeatsAndSteeringWheelBadges_a6_c9_s_line}
